var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact__info"},_vm._l((_vm.contactInfo),function(item,index){return _c('contact-info-item',_vm._b({key:index,attrs:{"icon":item.icon,"title":_vm.$t(`meta.contactInfoList.${item.title}`),"value":item.value}},'contact-info-item',item,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }